import React from "react";
import "./_sidebar-header.scss";

export default function SidebarHeader({ children }) {
  return <div className="sidebar-header">{children}</div>;
}
